import formsBackendClient, { type ApiDefinition } from '@/tsClient/servers/noodleQuestionnaires';

type ThisApi = ApiDefinition['/dynamic-pdf-templates/by-slug/{slug}/template-with-assets']['GET'];

type Input = ThisApi['params'];
type Output = ThisApi['response'];

const getDynamicPdfTemplateAndAssetsBySlug = async ({ slug }: Input): Promise<Output> => {
  try {
    const response = await formsBackendClient.get(`/dynamic-pdf-templates/by-slug/${slug}/template-with-assets`);
    return response.data;
  } catch (error) {
    console.error('Failed to fetch dynamic PDF templates by slug:', error);
    throw error;
  }
};

export default getDynamicPdfTemplateAndAssetsBySlug;
